import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate, NuInput } from "../../../../Components/Utils/Input";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import UseInspectorDD from "../../../../Components/Hooks/useInspectorSearch";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import axiosInstance from "../../../../Services/axiosCommon";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import CloseIcon from "../../../../Components/Icons/Close";
import { Video } from "lucide-react";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";

function EditRenewal() {
  const [searchClient, setSearchClient] = useState("");
  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const toast = useToast();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
 
  const { value: status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Renewals"
  );

  const { data: user } = UseDropDown(`/user/new-drop-down`);

  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  const from = location.state.from;
  // const sData = location.state?.data;

  const [data, setData] = useState(null);
  const { renewalEditId } = useParams();
  const [removefilePathList, setRemoveFilePathList] = useState([]);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };
  const navigate = useNavigate();
  // const data = location.state.data;

  const { editFormData, isLoading } = useEditFormData();
  const [createNew, setCreateNew] = useState([]);

  function getView() {
    axiosInstance
      .get(`/renewals/${renewalEditId}`)
      .then((res) => {
        res?.data?.data && setData(res?.data?.data);
        setCreateNew({
          clientId: res?.data?.data?.clientId || "",
          clientName: res?.data?.data?.clientName || "",
          contractRefNumber: res?.data?.data?.contractRefNumber || "",
          currentEndDate: res?.data?.data?.currentEndDate || "",
          proposedEndDate: res?.data?.data?.proposedEndDate || "",
          currentValue: res?.data?.data?.currentValue || "",
          proposedValue: res?.data?.data?.proposedValue || "",
          daysToExpire: res?.data?.data?.daysToExpire || "",
          refNumber: res?.data?.data?.refNumber || "",

          status: res?.data?.data?.status || "",
          filesToRemove: [],
          attachments: res?.data?.data?.attachments || [],
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!sData) {
    getView();
    // }
  }, []);

 
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      clientId: yup.string().required("Client is required!"),
     
    
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,

        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await editFormData({
        url: `/renewals/edit-renewal/${renewalEditId}`,
        formData: formData,
        navigateUrl: from || `/Contract-management/renewal`,
        resetForm: resetForm,
      });
    },
  });
   function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      // console.log(data.attachments, "ghjkllgd");
      setFilePathList(data?.attachments);

      setRemoveFilePathList(data?.attachments || []);
    }
  }, [data]);
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }
  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
    setIsModalOpen(true);
  }

  const { data: contract } = UseDropDown(`/contract/drop-down`);

  
const [Newclient, setclient] = useState([]);

function getContractsByClientId(clientId) {
  axiosInstance
    .get(`/contract/drop-down/client/${clientId}`)
    .then((res) => {
      if (Array.isArray(res.data)) {
        const formatted = res.data.map(item => ({
          value: item.id,        
          label: item.name      
        }));
        setclient(formatted);
        
        // Auto-select if there's only one contract
        if (res.data.length === 1) {
          formik.setFieldValue('contractId', res.data[0].id);
        }
      } else {
        console.error("Unexpected API response format");
        setclient([]);
        formik.setFieldValue('contractId', ''); // Clear contract if no options
      }
    })
    .catch(err => {
      console.error("Error fetching contracts by client ID:", err);
      setclient([]);
      formik.setFieldValue('contractId', ''); // Clear contract on error
    });
}

useEffect(() => {
  if (formik.values.clientId) {
    getContractsByClientId(formik.values.clientId);
  } else {
    setclient([]);
    formik.setFieldValue('contractId', ''); // Clear contract when no client selected
  }
}, [formik.values.clientId]);
  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="flex justify-between w-full ">
        <Breadcrumb
          items={[
            {
              name: "Renewal",
              link: "/Contract-management/renewal",
            },

            { name: "Edit" },
          ]}
        />
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
              <SettingHeading title={`Renewal : ${createNew?.refNumber}`} />
            </div>
           <FormikSelectTwo
  type="text"
  label="Client"
  placeholder="Client"
  Options={client}
  formik={formik}
  name="clientId"
  isRequired={true}
  width="w-full md:w-1/3 "
  handleClick={togglePopup}
  FixPosition={false}
  PortalTarget={true}
  setSearch={setSearchClient}
/>

<FormikSelectTwo
  label="Contract"
  Options={Newclient}
  formik={formik}
  placeholder={Newclient.length === 0 ? "No contracts available" : "Choose"}
  name="contractId"
  isRequired={true}
  width="w-full md:w-1/3 lg:w-1/3"
  // Optional: You might want to disable the dropdown if there's only one option
  isDisabled={Newclient.length === 1}
/>
            <NuDate
              label="Current End Date"
              placeholder="Current End Date"
              formik={formik}
              name="currentEndDate"
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="Proposed End Date"
              placeholder="Proposed End Date"
              formik={formik}
              name="proposedEndDate"
              width="w-full md:w-1/3 md:-mt-2"
            />

            {/* <NuInput
              type="text"
              label="Days to Expire"
              placeholder="Days to Expire"
              formik={formik}
              name="daysToExpire"
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

            <NuInput
              type="text"
              label="Current Value"
              placeholder="Current Value"
              formik={formik}
              name="currentValue"
              width="w-full md:w-1/3 md:-mt-2"
            />

            <NuInput
              type="text"
              label="Proposed Value"
              placeholder="Proposed Value"
              formik={formik}
              name="proposedValue"
              width="w-full md:w-1/3 md:-mt-2"
            />

            {/* <MultiSelect
                          label="Assignee"
                          Options={user}
                          formik={formik}
                          placeholder="Choose"
                          name="assignee"
                          isRequired={true}
                          width="w-full md:w-1/3 md:-mt-2"
                        />
                        <NuInput
                          type="text"
                          label="Location"
                          placeholder="Location"
                          formik={formik}
                          name="location"
                          width="w-full md:w-1/3 md:-mt-2"
                        /> */}

            <DropDownAddMetaData
              type="text"
              label="Status"
              placeholder="Status"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/3 lg:w-1/3 md:-mt-3"
              displayProperty={"Status"}
              propertyName={"Status_Renewals"}
              getFunc={refStatus}
            />

            {/* <NuTextArea
              type="text"
              label="Scope of Work"
              placeholder="Scope of Work"
              formik={formik}
              name="scope"
              width="w-full md:w-1/2 md:-mt-2"
            /> */}
            <div className="w-full">
              <SettingHeading title="Attachment" />

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full md:w-1/2"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            </div>
            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {filePathList &&
                  filePathList?.map((imgs, idx) => {
                    console.log("img", imgs);
                    let Ext = imgs?.file_name.split(".").reverse()[0];
                    return (
                      <div
                        className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                        key={idx}
                        style={{
                          border: "1px solid gray",
                          borderColor:
                            "rgb(148 163 184 / var(--tw-bg-opacity))",
                        }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs?.file)}
                        >
                          <CloseIcon color="white" height="8" width="8" />
                        </div>
                        <div
                          className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(imgs)}
                        >
                          <div className=" w-8 h-8">
                            {videotype.includes(Ext) ? <Video /> : null}

                            {Ext === ("docx" || "doc" || "txt") ? (
                              <Doc />
                            ) : Ext === ("xlsx" || "xls") ? (
                              <Xls />
                            ) : Ext === "txt" ? (
                              <Txt />
                            ) : Ext === "pdf" ? (
                              <Pdf />
                            ) : Ext === "PDF" ? (
                              <Pdf />
                            ) : Ext === "pptx" ? (
                              <>No file</>
                            ) : (
                              <img src={imgs?.file} alt="#" width="120%" />
                            )}
                          </div>
                          <p className=" w-[50px] text-[11px] truncate">
                            {imgs?.file_name}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditRenewal;
